import { formatGetHeaders } from '@configurations/api-configuration';
import { SubtypeGateway } from '@scenario/gateways/subtype.gateway';
import { Subtype } from '@scenario/models/subtype.model';
import { environment } from '../../../../../environments/environment';

export class ApiSubtypeGateway implements SubtypeGateway {
  private readonly subtypeApi = `${environment.backend_url}/api/v1/subtype`;
  async retrieveAll(): Promise<Subtype[]> {
    try {
      const response = await fetch(`${this.subtypeApi}`, await formatGetHeaders());
      return await response.json();
    } catch (error) {
      throw new Error('Error retrieving subtypes: ' + error);
    }
  }
}
